// ----------------------------------------------------------------------------
// Section: Progress Bar
// ----------------------------------------------------------------------------

// Style includes
import './_progress-bar.scss';

// -------------------------------------
// Variables
// -------------------------------------
var SECTION_SELECTOR = '[data-progress-bar]';
var SEGMENT_SELECTOR = '[data-progress-bar-segment]';
var RANGES_SELECTOR = '[data-progress-bar-ranges]';
var FILL_SELECTOR = '[data-progress-bar-fill]';
var FILLED_CLASS = 'is-filled';
var INITIALIZED_CLASS = 'is-initialized';
var READY_CLASS = 'is-ready';
var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// -------------------------------------
// Helpers
// -------------------------------------
function restartFill(section) {
  section.classList.remove(FILLED_CLASS);
  if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
    section.classList.add(FILLED_CLASS);
    return;
  }
  section.querySelectorAll(FILL_SELECTOR).forEach(fill => {
    fill.getBoundingClientRect();
  });
  requestAnimationFrame(() => {
    section.classList.add(FILLED_CLASS);
  });
}
function resetFill(section) {
  section.classList.remove(FILLED_CLASS);
}
function isDesignMode() {
  return window.Shopify && window.Shopify.designMode;
}
function createRangeElement(label) {
  var range = document.createElement('div');
  range.className = 'progress-bar__range';
  if (label) {
    var rangeLabel = document.createElement('span');
    rangeLabel.className = 'progress-bar__range-label';
    rangeLabel.textContent = label;
    range.append(rangeLabel);
  }
  return range;
}
function setupDesktopRanges(section) {
  var segments = Array.from(section.querySelectorAll(SEGMENT_SELECTOR));
  var ranges = section.querySelector(RANGES_SELECTOR);
  if (!segments.length) {
    section.hidden = !isDesignMode();
    return false;
  }
  section.hidden = false;
  section.style.setProperty('--progress-bar-segment-count', segments.length);
  if (ranges) {
    ranges.replaceChildren(...segments.map(segment => createRangeElement(segment.dataset.progressBarRangeLabel || '')));
  }
  section.classList.add(READY_CLASS);
  return true;
}
function initSection(section) {
  if (!section || section.classList.contains(INITIALIZED_CLASS)) {
    return;
  }
  section.classList.add(INITIALIZED_CLASS);
  if (!setupDesktopRanges(section)) {
    return;
  }
  if (!('IntersectionObserver' in window)) {
    section.classList.add(FILLED_CLASS);
    return;
  }
  var observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        restartFill(entry.target);
      } else {
        resetFill(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -15% 0px',
    threshold: 0.25
  });
  observer.observe(section);
}
function initProgressBars() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  if (container.matches && container.matches(SECTION_SELECTOR)) {
    initSection(container);
  }
  container.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
}

// -------------------------------------
// Init
// -------------------------------------
initProgressBars();
document.addEventListener('shopify:section:load', event => {
  initProgressBars(event.target);
});